const lt = {
  common: {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    phone: 'Telefonas',
    email: 'El. paštas',
    office: 'Biuras',
    availability: 'Pasiekiamumas',
    support: 'Pagalba',
    preOrder: 'Išankstinis užsakymas',
    clearForm: 'Išvalyti formą',
    sending: 'Siunčiama...',
    select: 'Pasirinkite',
    closeNotification: 'Uždaryti pranešimą',
  },
  nav: {
    home: 'Pagrindinis',
    about: 'Apie mus',
    preOrder: 'Išankstinis užsakymas',
    contacts: 'Kontaktai',
    startPreOrder: 'Pradėti išankstinį užsakymą',
    openMenu: 'Atidaryti meniu',
    closeMenu: 'Uždaryti meniu',
    logoAria: 'KUB AUTO pradinis puslapis',
    languageSwitcher: 'Kalba',
  },
  seo: {
    defaultTitle: 'KUB AUTO — Premium automobilių išankstinis užsakymas visoje Europoje',
    defaultDescription: 'Premium automobilių paieška, patikra, pirkimas ir pristatymas visoje Europoje su aiškiomis sąlygomis ir teisiniu saugumu.',
    home: {
      title: 'KUB AUTO — Premium automobilių išankstinis užsakymas visoje Europoje',
      description: 'Premium automobilių paieška, patikra, pirkimas ir pristatymas visoje Europoje su aiškiomis sąlygomis ir teisiniu saugumu.',
    },
    about: {
      title: 'Apie KUB AUTO — premium automobilių įsigijimo paslauga',
      description: 'Sužinokite, kaip KUB AUTO organizuoja premium automobilių paiešką, patikrą, sutarčių sudarymą, logistiką ir perdavimą visoje Europoje.',
    },
    preOrder: {
      title: 'Išankstinio užsakymo forma — pateikite automobilio reikalavimus | KUB AUTO',
      description: 'Pateikite savo premium automobilio reikalavimus ir gaukite patikrintus variantus, aiškias sąlygas ir sutartimi paremtą procesą.',
    },
    contacts: {
      title: 'Kontaktai — KUB AUTO concierge',
      description: 'Susisiekite su KUB AUTO per WhatsApp, Telegram arba el. paštu dėl premium automobilių konsultacijų ir išankstinių užsakymų.',
    },
  },
  home: {
    gallery: {
      kicker: 'ATRINKTI AUTOMOBILIAI',
      title: 'Tikri premium automobiliai iš naujausių užsakymų',
      sub: 'Tai realūs automobiliai, kuriuos neseniai atrinkome ir pristatėme klientams. Kiekvienas jų atspindi mūsų kokybės, patikros ir aukšto aptarnavimo standartus.',
    },
    hero: {
      kicker: 'PRIVATI ĮSIGIJIMO PASLAUGA',
      title: 'Premium automobiliai pagal individualų išankstinį užsakymą',
      lead: 'Paieška, patikra, pirkimas ir pristatymas visoje Europoje — su aiškiomis sąlygomis ir teisiniu saugumu.',
      cta: 'Pradėti išankstinį užsakymą',
      pills: ['Pagal sutartį', 'Oficialios duomenų bazės', 'Pilnas palaikymas'],
      cardTitle: 'Ką gaunate',
      badge: 'STANDARTAS',
      bullets: [
        'Dokumentuotas procesas ir fiksuoti mokesčiai',
        'Techninė ir teisinė patikra prieš pirkimą',
        'Logistika, muitinė, sertifikavimas ir perdavimas',
      ],
    },
    process: {
      title: 'Procesas',
      sub: 'Aiškus, dokumentuotas, prognozuojamas.',
      steps: [
        { title: 'Užklausa', sub: 'Reikalavimai' },
        { title: 'Rinkos analizė', sub: 'Patikrinti šaltiniai' },
        { title: 'Patikra', sub: 'Teisinė + techninė' },
        { title: 'Sutartis', sub: 'Fiksuotos sąlygos' },
        { title: 'Pristatymas', sub: 'Perdavimas' },
      ],
      ctaTitle: 'Pateikite reikalavimus — grįšime su patikrintais variantais',
      ctaText: 'Įprastas paieškos laikas: nuo kelių dienų iki dviejų savaičių.',
      cta: 'Pradėti išankstinį užsakymą',
    },
    trust: {
      title: 'Kodėl klientai mumis pasitiki',
      sub: 'Skaidrumas + teisinis saugumas viso sandorio metu.',
      cards: [
        { title: 'Oficiali sutartis', text: 'Kainos, etapai ir terminai fiksuojami.' },
        { title: 'Patikra', text: 'Oficialios duomenų bazės + ataskaitos.' },
        { title: 'Pilnas aptarnavimas', text: 'Logistika, muitinė, sertifikavimas.' },
      ],
      missionTitle: 'Reglamentuota procedūra',
      missionText: 'Paieška → patikra → suderinimas → sutartis → pirkimas → pristatymas → perdavimas. Kiekvienas žingsnis dokumentuojamas.',
      cta: 'Gauti konsultaciją',
    },
    reviewsFaq: {
      reviewsTitle: 'Klientų atsiliepimai',
      reviewsSub: 'Trumpi atsiliepimai klientų, vertinančių prognozuojamumą, aiškumą ir kontrolę.',
      reviews: [
        {
          quote: '„Viskas atitiko tai, dėl ko susitarėme.“',
          text: 'Aiškūs žingsniai, reguliarūs atnaujinimai ir jokio spaudimo. Kaina ir terminas liko tokie, kaip aptarta, o perdavimas vyko sklandžiai.',
          meta: 'Andrius Kazlauskas, Vilnius (LT)',
        },
        {
          quote: '„Kiekviename etape žinojau, kas vyksta.“',
          text: 'Siuntė variantus su visa informacija, paaiškino, į ką atkreipti dėmesį, ir tvarkingai sutvarkė dokumentus. Jokių nereikalingų skambučių — tik aiški komunikacija.',
          meta: 'Nerijus Šimkus, Kaunas (LT)',
        },
        {
          quote: '„Automobilis atvyko tiksliai toks, kaip buvo aprašytas.“',
          text: 'Patikros rezultatai buvo pateikti iš anksto, logistika suorganizuota be vėlavimų, dokumentai paruošti laiku. Apskritai — profesionalus ir ramus procesas.',
          meta: 'Mārtiņš Pētersons, Ryga (LV)',
        },
      ],
      faqTitle: 'DUK',
      faqSub: 'Atsakymai į dažniausiai užduodamus klausimus apie procesą.',
      faq: [
        { q: 'Kaip pradėti išankstinį užsakymą?', a: 'Užpildykite išankstinio užsakymo formą su savo reikalavimais. Mes patikslinsime detales ir pradėsime paiešką.' },
        { q: 'Kiek laiko trunka automobilio paieška?', a: 'Paprastai nuo kelių dienų iki dviejų savaičių, priklausomai nuo reikalavimų sudėtingumo.' },
        { q: 'Kaip tikrinami automobiliai?', a: 'Kiekvienas automobilis tikrinamas techniškai ir teisiškai pagal oficialias duomenų bazes bei apžiūros ataskaitas.' },
        { q: 'Kada pasirašoma sutartis?', a: 'Kai patvirtinate konkretų automobilį ir suderinamos visos sąlygos.' },
        { q: 'Kokios išlaidos fiksuojamos iš anksto?', a: 'Paslaugos mokestis, logistika, muitinės procedūros ir privalomi mokesčiai fiksuojami sutartyje.' },
        { q: 'Kas vyksta po automobilio pirkimo?', a: 'Mes organizuojame logistiką, muitinės procedūras, sertifikavimą ir paruošimą perdavimui.' },
        { q: 'Kada gausiu automobilį?', a: 'Baigus visas procedūras ir patikrinus dokumentus, automobilis perduodamas jums.' },
        { q: 'Ar galiu atsisakyti pasirinkto automobilio?', a: 'Taip. Paieška tęsiama tol, kol patvirtinamas jūsų reikalavimus visiškai atitinkantis variantas.' },
        { q: 'Ar dirbate ir su įmonėmis, ir su privačiais klientais?', a: 'Taip. Dirbame tiek su fiziniais, tiek su juridiniais asmenimis pagal oficialią sutartį.' },
        { q: 'Kokiose šalyse ieškote automobilių?', a: 'Automobilius ieškome visoje Europoje, bendradarbiaudami tik su patikrintais tiekėjais ir aukcionų platformomis.' },
        { q: 'Ar įskaičiuotas pristatymas ir muitinė?', a: 'Taip. Visa logistika, muitinė ir sertifikavimas yra mūsų paslaugos dalis.' },
      ],
    },
    finalCta: {
      kicker: 'PASIRUOŠĘ PRADĖTI',
      title: 'Pradėkite savo išankstinio užsakymo užklausą',
      sub: 'Atsakysime su patikrintais variantais ir aiškiomis sąlygomis.',
      cta: 'Pereiti prie išankstinio užsakymo',
    },
  },
  about: {
    hero: {
      kicker: 'APIE ĮMONĘ',
      title: 'Premium automobiliai pagal individualų išankstinį užsakymą visoje Europoje',
      lead: 'Teikiame profesionalią premium automobilių paiešką, patikrą ir įsigijimą pagal individualų kliento užsakymą, su pilnu teisiniu ir logistiniu palaikymu nuo pirmos paieškos iki galutinio perdavimo.',
      cta: 'Pateikti išankstinio užsakymo užklausą',
    },
    overview: {
      title: 'Bendra apžvalga',
      sub: 'Mūsų paslaugos skirtos klientams, kurie vertina skaidrumą, struktūruotus procesus ir teisinį saugumą.',
      cards: [
        {
          title: 'Veiklos sritis',
          text: 'Įmonė specializuojasi premium automobilių paieškoje, patikroje ir pirkime Europos rinkoje, įskaitant oficialius atstovus, patikrintus tiekėjus ir aukcionų platformas. Visi etapai — nuo pirminės atrankos iki automobilio perdavimo — vykdomi pagal vieningą kokybės standartą ir suderintus terminus.',
        },
        {
          title: 'Pilnas palaikymas',
          text: 'Mes užtikriname automobilio parinkimą pagal nustatytus kriterijus, dokumentuotą techninę ir teisinę patikrą, darbų apimties ir kainos fiksavimą sutartyje, pirkimo organizavimą, logistiką, muitinę, sertifikavimą ir automobilio paruošimą galutiniam perdavimui.',
        },
      ],
    },
    principles: {
      title: 'Darbo principai',
      sub: 'Struktūruotas, dokumentuotas procesas su aiškia atsakomybe kiekviename etape.',
      cards: [
        { icon: '✓', title: 'Formalumas ir skaidrumas', text: 'Visi bendradarbiavimo etapai ir paslaugų mokesčiai fiksuojami sutartyje. Klientas aiškiai supranta procesą, terminus ir kiekvienos šalies įsipareigojimus.' },
        { icon: '🧾', title: 'Išsami automobilio patikra', text: 'Kiekvienas automobilis pereina techninę ir teisinę patikrą naudojant oficialias duomenų bazes, serviso istoriją ir, jei reikia, nepriklausomą ekspertinę apžiūrą.' },
        { icon: '🎯', title: 'Individualus požiūris', text: 'Automobilio paieška vykdoma griežtai pagal kliento biudžetą, pageidavimus ir naudojimo paskirtį — be atsitiktinių ar netinkamų pasiūlymų.' },
        { icon: '🛡', title: 'Pilnas palaikymas', text: 'Organizuojame pirkimą, logistiką, muitinę, sertifikavimą ir automobilio paruošimą perdavimui, mažindami rizikas ir kliento įsitraukimą.' },
      ],
    },
    advantages: {
      title: 'Pagrindiniai privalumai',
      sub: 'Kodėl klientai renkasi individualų išankstinį užsakymą su profesionaliu palaikymu.',
      items: [
        'Patvirtinta premium automobilių segmento ekspertizė',
        'Bendradarbiavimas tik su patikrintais tiekėjais ir aukcionų platformomis',
        'Aiškiai struktūruotas darbo procesas ir griežtas terminų laikymasis',
        'Atsakomybė už rezultatą kiekviename sandorio etape',
      ],
    },
    mission: {
      kicker: 'MISIJA',
      title: 'Suteikti prieigą prie premium automobilių su garantuota kokybe ir teisiniu saugumu.',
      text: 'Teikiame struktūruotą, skaidrią ir profesionalią paslaugą kiekviename etape — nuo pirminės paieškos iki galutinio automobilio perdavimo su pilnu dokumentų paketu.',
      ctaPrimary: 'Pateikti išankstinio užsakymo užklausą',
      ctaSecondary: 'Susisiekti su mumis',
    },
    process: {
      title: 'Kaip veikia išankstinio užsakymo procesas',
      sub: 'Nuosekli procedūra su apibrėžtais etapais ir kontrolės taškais.',
      steps: [
        { num: '01', title: 'Užklausa', text: 'Pateikiate automobilio parametrus ir individualius reikalavimus.' },
        { num: '02', title: 'Paieška', text: 'Parenkame ir pristatome patikrintus variantus, atitinkančius jūsų kriterijus.' },
        { num: '03', title: 'Sutartis', text: 'Visos sąlygos, etapai ir paslaugų mokesčiai fiksuojami sutartyje.' },
        { num: '04', title: 'Pirkimas ir logistika', text: 'Organizuojame pirkimą, pristatymą, muitinės procedūras ir sertifikavimą.' },
        { num: '05', title: 'Perdavimas', text: 'Automobilis paruošiamas ir perduodamas su pilnu dokumentų rinkiniu.' },
      ],
      ctaPrimary: 'Pateikti išankstinio užsakymo užklausą',
      ctaSecondary: 'Užduoti klausimą per Telegram',
    },
  },
  contacts: {
    hero: {
      kicker: 'KONTAKTAI',
      title: 'Susisiekite su mumis',
      lead: 'Greičiausias būdas: WhatsApp. Konsultacijoms ir išankstiniams užsakymams esame pasiekiami 24/7.',
    },
    primary: {
      title: 'KUB AUTO Concierge',
      emailUs: 'Parašykite mums',
      telegramCta: 'Pirmenybę teikiate Telegram? Atidarykite pokalbį →',
    },
    office: {
      label: 'Biuro adresas',
      address: 'Dzūkų g. 6a, Vilnius, 02163 Vilniaus m. sav.',
      badge: '24/7',
      hoursLabel: 'Darbo laikas',
      hoursValue: '24/7',
      supportLabel: 'Pagalba',
      supportValue: 'WhatsApp / El. paštas',
      preOrderLabel: 'Išankstinis užsakymas',
      preOrderValue: 'Procesas pagal sutartį',
      openMaps: 'Atidaryti Google Maps',
      mapTitle: 'KUB AUTO biuro žemėlapis',
    },
    form: {
      title: 'Greita žinutė',
      sub: 'Palikite trumpą žinutę — atsakysime kuo greičiau.',
      nameLabel: 'Jūsų vardas',
      namePlaceholder: 'Pilnas vardas',
      emailLabel: 'El. paštas',
      emailPlaceholder: 'name@example.com',
      messageLabel: 'Žinutė',
      messagePlaceholder: 'Kokio automobilio ieškote? Biudžetas, metai, rida, pageidavimai...',
      submit: 'Siųsti žinutę',
      success: 'Žinutė sėkmingai išsiųsta. Netrukus su jumis susisieksime.',
      error: 'Nepavyko išsiųsti žinutės.',
    },
  },
  preOrder: {
    hero: {
      kicker: 'IŠANKSTINIO UŽSAKYMO FORMA',
      title: 'Pateikite automobilio reikalavimus',
      lead: 'Peržiūrėsime jūsų užklausą ir atsakysime patikrintais variantais bei aiškiomis sąlygomis.',
    },
    vehicle: {
      title: 'Automobilio duomenys',
      sub: 'Pagrindiniai parametrai paieškai pradėti.',
      make: 'Markė',
      makePlaceholder: 'pvz. BMW',
      model: 'Modelis',
      modelPlaceholder: 'pvz. X5',
      year: 'Metai',
      yearPlaceholder: 'pvz. 2020',
      mileage: 'Rida (km)',
      mileagePlaceholder: 'pvz. 45000',
      fuelType: 'Kuro tipas',
      bodyType: 'Kėbulo tipas',
      preferences: 'Papildomi pageidavimai',
      preferencesPlaceholder: 'Komplektacija, spalva, salonas, būklė, naudojimo istorija, specialūs reikalavimai...',
      fuelOptions: [
        { value: 'petrol', label: 'Benzinas' },
        { value: 'diesel', label: 'Dyzelinas' },
        { value: 'hybrid', label: 'Hibridas' },
        { value: 'electric', label: 'Elektra' },
      ],
      bodyOptions: [
        { value: 'sedan', label: 'Sedanas' },
        { value: 'wagon', label: 'Universalas' },
        { value: 'coupe', label: 'Kupė' },
        { value: 'suv', label: 'SUV' },
        { value: 'hatchback', label: 'Hečbekas' },
        { value: 'other', label: 'Kita' },
      ],
    },
    buyer: {
      title: 'Pirkėjo informacija',
      sub: 'Sutarčiai ir komunikacijai.',
      buyerType: 'Pirkėjo tipas',
      buyerTypeOptions: [
        { value: 'individual', label: 'Fizinis asmuo' },
        { value: 'company', label: 'Įmonė' },
      ],
      buyerName: 'Vardas / Įmonė',
      buyerNamePlaceholder: 'Pilnas vardas arba juridinis asmuo',
      address: 'Adresas',
      addressPlaceholder: 'Gatvė, miestas, šalis',
      phone: 'Telefonas',
      phonePlaceholder: '+370 688 03122',
      email: 'El. paštas',
      emailPlaceholder: 'name@example.com',
      submit: 'Pateikti užklausą',
      askWhatsapp: 'Klausti per WhatsApp',
      askTelegram: 'Klausti per Telegram',
      success: 'Užklausa sėkmingai išsiųsta. Netrukus su jumis susisieksime.',
      error: 'Nepavyko išsiųsti užklausos.',
    },
    validation: {
      required: 'Privaloma',
      yearFormat: 'Įveskite 4 skaitmenis (pvz. 2020)',
      numbersOnly: 'Tik skaičiai',
      tooLong: 'Per ilga',
      invalidPhone: 'Naudokite tarptautinį formatą, pvz. +37068803122',
      invalidEmail: 'Neteisingas el. paštas',
      invalid: 'Neteisinga',
    },
  },
  validation: {
    tooShort: 'Per trumpa',
    tooLong: 'Per ilga',
    required: 'Privaloma',
    invalidEmail: 'Neteisingas el. paštas',
    invalid: 'Neteisinga',
    unknownError: 'Nežinoma klaida',
  },
};

export default lt;
